import BiasPanel from './BiasPanel';

export default BiasPanel;
